<template>

	<v-app>

		<div style="background: #f4f4f4;">
    	
    	<v-container class="mt-5 mb-5" id="terms-condition">

    		<v-row>

    			<v-col offset-lg="2" lg="8" style="text-align: justify;">

    				<h2 class="text-center">Política de Privacidad</h2><br>

    				<div v-html="privacy"></div>

    			</v-col>

    		</v-row>

    	</v-container>

    </div>

	</v-app>

</template>


<script>
	
	import TermsService from '@/shared/services/TermsService'

	export default
	{
		data() {
			return {
				privacy: null
			}
		},

		created() {
			this.getPrivacy()
		},

		methods: {

			async getPrivacy()
			{
				const resp = await TermsService.get()
				this.privacy = resp.data.privacy 
			}

		}
	}

</script>